var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg_icons_wrpr",domProps:{"innerHTML":_vm._s(_vm.icon ? _vm.icons[_vm.icon] : '')}})
}
var staticRenderFns = []

export { render, staticRenderFns }